"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OracleModerationMessage = void 0;
var react_1 = __importDefault(require("react"));
var StaticTextContext_1 = require("../OraclePage/StaticTextContext");
/**
 * Displays moderation error messages inline in chat.
 * Used by both OraclePage (Sage on the Stage) and OracleSideGuide (Guide on the Side).
 *
 * Features:
 * - Severity-based styling (border colors, backgrounds)
 * - Crisis resources with country disclaimer for self-harm content
 * - Logging notice for threatening content
 * - Generic fallback for unknown moderation types
 */
var OracleModerationMessage = function (_a) {
    var severity = _a.severity, showCrisisResources = _a.showCrisisResources, _b = _a.className, className = _b === void 0 ? '' : _b;
    // Get translated text for the severity level
    var title = (0, StaticTextContext_1.useTranslatedText)({ keys: ['moderation', severity, 'title'] });
    var body = (0, StaticTextContext_1.useTranslatedText)({ keys: ['moderation', severity, 'body'] });
    // Crisis resources text
    var crisisTitle = (0, StaticTextContext_1.useTranslatedText)({ keys: ['moderation', 'crisisTitle'] });
    var crisisBody = (0, StaticTextContext_1.useTranslatedText)({ keys: ['moderation', 'crisisBody'] });
    var crisisInternational = (0, StaticTextContext_1.useTranslatedText)({ keys: ['moderation', 'crisisInternational'] });
    // Logging notice for threatening content
    var loggingNotice = (0, StaticTextContext_1.useTranslatedText)({ keys: ['moderation', 'loggingNotice'] });
    var severityClass = severity.toLowerCase().replace(/_/g, '-');
    var showLoggingNotice = severity === 'CRITICAL_THREAT';
    return (react_1.default.createElement("div", { className: "oracle-moderation-message ".concat(className).trim() },
        react_1.default.createElement("div", { className: "oracle-moderation-message__container oracle-moderation-message--".concat(severityClass) },
            react_1.default.createElement("div", { className: "oracle-moderation-message__icon" },
                react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
                    react_1.default.createElement("path", { d: "M12 9V13M12 17H12.01M12 3L2 21H22L12 3Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
            react_1.default.createElement("div", { className: "oracle-moderation-message__content" },
                react_1.default.createElement("h4", { className: "oracle-moderation-message__title" }, title),
                react_1.default.createElement("p", { className: "oracle-moderation-message__body" }, body),
                showCrisisResources && (react_1.default.createElement("div", { className: "oracle-moderation-message__crisis" },
                    react_1.default.createElement("p", { className: "oracle-moderation-message__crisis-title" }, crisisTitle),
                    react_1.default.createElement("p", { className: "oracle-moderation-message__crisis-body" }, crisisBody),
                    react_1.default.createElement("a", { href: "tel:988", className: "oracle-moderation-message__crisis-phone", "aria-label": "Call 988 crisis lifeline" }, "988"),
                    react_1.default.createElement("p", { className: "oracle-moderation-message__crisis-international" },
                        crisisInternational,
                        ' ',
                        react_1.default.createElement("a", { href: "https://findahelpline.com", target: "_blank", rel: "noopener noreferrer", className: "oracle-moderation-message__crisis-link" }, "findahelpline.com")))),
                showLoggingNotice && (react_1.default.createElement("p", { className: "oracle-moderation-message__notice" }, loggingNotice))))));
};
exports.OracleModerationMessage = OracleModerationMessage;
exports.default = exports.OracleModerationMessage;
